import { Modal } from 'antd';
import type { ModalProps } from 'antd';

export interface DialogProps extends Omit<ModalProps, 'open' | 'onCancel'> {
  open: boolean;
  /** Đổi tên từ `onCancel` của antd cho dễ đọc. */
  onClose: () => void;
}

/**
 * Hộp thoại (§9.3.13).
 *
 * Bọc `Modal` của antd nên đã có sẵn bẫy focus, đóng bằng Esc và trả focus về
 * chỗ cũ. ❌ Không bao giờ tự dựng modal bằng `position: fixed` — làm vậy mất
 * cả ba thứ trên (§18.3 mục 9).
 *
 * `footer` mặc định là `null`: đặt nút vào `children`, hoặc truyền `footer`
 * tường minh. Bán kính do antd tự quyết, không ghi đè.
 *
 * Thân hộp **tự cuộn** khi nội dung cao quá (`styles.body`), nên form dài không
 * đẩy tiêu đề trôi khỏi màn hình. Vì vậy từng form **không cần** tự đặt
 * `max-h-*` cho vùng nội dung của mình nữa.
 *
 * Mẫu xác nhận hành động phá hủy:
 *   <Dialog open={open} onClose={close} title='Xóa người dùng'
 *           okText="Xóa" okButtonProps={{ danger: true }} onOk={handleDelete}>
 */
export function Dialog({ open, onClose, footer = null, children, styles, ...props }: DialogProps) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={footer}
      // Thân cuộn trong khung, không đẩy cả hộp tràn khỏi màn hình. `Modal` của antd căn giữa dọc
      // và không tự giới hạn chiều cao, nên form dài (ví dụ tạo vai trò: hai ô + lưới quyền) làm
      // mép trên của hộp — kể cả tiêu đề — trôi lên trên vùng nhìn thấy và không cuộn tới được.
      // 60vh chừa chỗ cho tiêu đề, footer và lề của chính Modal ở màn hình laptop 768px.
      // Hộp nào cần khác thì truyền `styles.body` của riêng nó; giá trị đó ghi đè dòng dưới.
      styles={{ body: { maxHeight: '60vh', overflowY: 'auto' }, ...styles }}
      {...props}
    >
      {children}
    </Modal>
  );
}
